// ⚠️ BIRINCHI import — zod sxemalari qurilishidan OLDIN baholanishi shart
// (sabab `shared/src/zod-jitless.ts` da).
import "@shared/zod-jitless";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import apiClient from "./app/api/client";
// ⚠️ i18next'ni ishga tushiradi (`import.meta.glob` bilan namespace
// resurslarini yig'ib) — P7 spec §6. `zod-jitless`dan KEYIN, chunki
// tartib qorovuli faqat BIRINCHI importni tekshiradi (`zod-jitless-order.test.ts`),
// lekin mantiqiy sabab ham bor: bu yerdan keyingi hech narsa zod sxemasi
// qurmaydi, shuning uchun tartib erkin. Faqat `initialLocale` named import
// qilinadi — modulning o'zi (default eksport) yon ta'sir uchun baribir
// baholanadi, alohida `i18n` o'zgaruvchisi shart emas.
import { initialLocale } from "./app/i18n";
import "./index.css";
import App from "./App.tsx";

// Birinchi so'rovdanoq to'g'ri `X-Locale` sarlavhasi ketishi uchun —
// keyingi almashtirishlar `useChangeLocale()` orqali.
apiClient.defaults.headers.common["X-Locale"] = initialLocale;

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>
);
